import { Component, OnInit } from '@angular/core';
import { IDialogContentComponent } from '../../modal-dialog/modal-dialog.service';

@Component({
  selector: 'app-scc-upload-confirmed',
  standalone: true,
  imports: [],
  templateUrl: './scc-upload-confirmed.component.html',
  styleUrl: './scc-upload-confirmed.component.scss'
})
export class SccUploadConfirmedComponent implements OnInit, IDialogContentComponent<boolean, undefined> {
  input?: undefined;

  ngOnInit(): void {}

  getResult(): boolean {
    return true;
  }

  isDisabled(): boolean {
    return false;
  }
}
